<template>
<div>
  <VtoolBarHome></VtoolBarHome>
  <v-content>
    <v-container grid-list-lg>
      <v-layout justify-center row wrap>
        <v-flex xs12 md10 lg8>
          <UserProfile/>
          <ChangePassword/>
        </v-flex>
      </v-layout>
    </v-container>
  </v-content>
</div>
    
</template>

<script>

import VtoolBarHome from '../components/VtoolBarHome';
import UserProfile from '../components/UserProfile';
import ChangePassword from '../components/ChangePassword';

export default {
  name: 'UserProfileView',
  components: {
    VtoolBarHome,
    UserProfile,
    ChangePassword,
  }

}
</script>

<style>

</style>

